import React from 'react';
import styled from 'styled-components';

// STYLE-COMPONENTS
// ===================================
const Form = styled.form`
  width: 100%;
  max-width: 100%;
`;

// PROPS
// ===================================
Form.defaultProps = {
  onSubmit: () => {},
  style: {},
};

// EXPORT
// ===================================
export default ({
  onSubmit, children, style, theme,
}) => (
  <Form onSubmit={onSubmit} theme={theme} style={style}>
    {children}
  </Form>
);



// WEBPACK FOOTER //
// ./src/components/common/Form/index.js